/* eslint-disable no-param-reassign */
import qs from 'qs';
import { createSnack } from 'snackbar/snackbarSlice';
import http from 'utils/http';

let fetchController;
const fetchCSVReport =
  ({ affiliates, startDate, endDate }) =>
  dispatch => {
    const paramString = qs.stringify(affiliates, {
      allowDots: true,
      encode: false,
    });
    if (fetchController) fetchController.abort();
    fetchController = new AbortController();
    const { signal } = fetchController;
    return http
      .get(
        `/product-transfer-orders/export?${paramString}&FromDate=${startDate}&ToDate=${endDate}`,
        { signal }
      )
      .catch(error => {
        dispatch(
          createSnack({
            message: error.response.data.title,
            options: { variant: 'error' },
          })
        );
      });
  };

export default fetchCSVReport;
